import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import IP_URL from "../Components/connect";
import { jwtDecode } from "jwt-decode";

// ✅ Async thunk to refresh access token (using fetch)
export const refreshToken = createAsyncThunk(
  "user/refreshToken",
  async (_, { getState, rejectWithValue }) => {
    try {
      const response = await fetch(`${IP_URL}/auth/refresh-token`, {
        method: "POST",
        credentials: "include", // send HttpOnly cookie
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error("Failed to refresh token");

      const data = await response.json();
      const token = data.token;
      if (!token) throw new Error("No access token returned");

      const user = getState().user;
      return { ...user, token: token };
    } catch (err) {
      console.error("Token refresh failed:", err);
      return rejectWithValue("Session expired");
    }
  }
);

const initialState = {
  username: "",
  uniqueKey: "",
  role: "",
  email: "",
  token: "", // transient
  status: "idle",
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { username, uniqueKey, role, email, token } = action.payload;
      state.username = username;
      state.uniqueKey = uniqueKey;
      state.role = role;
      state.email = email;
      state.token = token;
    },
    logout: (state) => {
      state.username = "";
      state.uniqueKey = "";
      state.role = "";
      state.email = ""
      state.token = "";
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshToken.pending, (state) => {
        state.status = "loading";
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.token = action.payload.token;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.token = "";
      });
  },
});

// --- Auto-refresh token on page load ---
export const initializeAuth = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const currentToken = state.user.token;

    //if there is a valid token check expiry
    if (currentToken && !isTokenExpired(currentToken)) {
      return; // still valid no refresh needed
    }
    
    //Try to refresh if expired
    const response = await fetch(`${IP_URL}/auth/refresh-token`,{
      method: "POST",
      credentials: "include",
    })



    if (response.ok) {
      const data = await response.json();
      dispatch(
        loginSuccess({
          username: data.user.userName,
          uniqueKey: data.user.uniqueKey,
          role: data.user.accountType,
          email: data.user.email,
          token: data.token,
        })
      );
    } else {
      console.warn("No valid session, user must log in again.");
      dispatch(logout());
    }
  } catch (error) {
    console.error("Auth init failed:", error);
    dispatch(logout());
  }
};



export const { loginSuccess, logout } = userSlice.actions;
export const selectUser = (state) => state.user;
export default userSlice.reducer;




export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};
